import React from 'react';
import PropTypes from 'prop-types';

import mergeClassName from 'merge-class-names';

import { createUseStyles, createUseColoredStyles } from '../../palette';
import decorate from '../../common/utils/decorate';

const useMainStyles = createUseStyles((theme) => ({
  text: {
    ...theme.standarts('text')
  },

  strong: {
    fontWeight: 600
  }
}));

const useVariantStylesMap = createUseColoredStyles((theme, color) => ({
  normal: {
    color: theme.getColor('text', color, 'contrast')
  },

  invert: {
    color: theme.getColor('text', color, 'value')
  }
}));

const useSizeStyles = createUseStyles((theme) => ({
  xs: {
    fontSize: theme.getFactor('text', 'font.size', 0.57)
  },

  xs2: {
    fontSize: theme.getFactor('text', 'font.size', 0.714)
  },

  sm: {
    fontSize: theme.getFactor('text', 'font.size', 0.857)
  },

  //md: {},

  lg: {
    fontSize: theme.getFactor('text', 'font.size', 1.286)
  },

  xl: {
    fontSize: theme.getFactor('text', 'font.size', 1.786)
  },

  xl2: {
    fontSize: theme.getFactor('text', 'font.size', 2.5)
  }
}));

const useAlignStyles = createUseStyles((theme) => ({
  center: {
    textAlign: 'center'
  },

  left: {
    textAlign: 'left'
  },

  right: {
    textAlign: 'right'
  }
}));

const useWhiteSpaceStyles = createUseStyles((theme) => ({
  nowrap: {
    whiteSpace: 'nowrap'
  },

  pre: {
    whiteSpace: 'pre'
  }
}));

const useDecoration = createUseStyles((theme) => ({
  overline: {
    textDecoration: 'overline'
  },

  strike: {
    textDecoration: 'line-through'
  },

  underline: {
    textDecoration: 'underline'
  }
}));

export default decorate(
  class extends React.PureComponent {
    static decorateWith = {
      classes: {
        main: useMainStyles,
        variant: useVariantStylesMap,
        size: useSizeStyles,
        align: useAlignStyles,
        whiteSpace: useWhiteSpaceStyles,
        decoration: useDecoration
      }
    };

    static propTypes = {
      strong: PropTypes.bool,
      variant: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      size: PropTypes.string,
      align: PropTypes.string,
      whiteSpace: PropTypes.string
    };

    static defaultProps = {
      variant: 'normal',
      color: 'basic'
    };

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const {
        classes,
        children,
        strong,
        variant,
        color,
        size,
        align,
        whiteSpace,
        decoration,
        ...props
      } = this.props;

      const mergedClassName = mergeClassName(
        classes.main.text,
        strong && classes.main.strong,
        (classes.variant[color] ?? classes.variant.basic)[variant],
        size && classes.size[size],
        align && classes.align[align],
        whiteSpace && classes.whiteSpace[whiteSpace],
        decoration && classes.decoration[decoration]
      );

      return (
        <span {...props} className={mergedClassName}>
          {children}
        </span>
      );
    }
  }
);
